import { ActionTypes } from 'utils/constants';

export const contentStats = (state = {}, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_CONTENT_STATS + '_PENDING': {
            return {
                ...state,
                fetching: true
            };
        }
        case ActionTypes.FETCH_CONTENT_STATS + '_FULFILLED': {
            const stats = action.payload.data;
            
            return {
                ...state,
                fetching: false,
                fetched: true,
                stats
            };
        }
        case ActionTypes.FETCH_CONTENT_STATS + '_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }
        default: {
            return state;
        }
    }
};
